import { useEffect, useState } from "react";
import { Monitor, Smartphone, Tablet } from "lucide-react";
import { BACKEND, BACKEND_ORIGIN } from "@/lib/api";

const SIZES = [["desktop", "100%", Monitor, "Desktop"], ["tablet", "768px", Tablet, "Nettbrett"], ["mobile", "390px", Smartphone, "Mobil"]];

const Frame = ({ src, k, title, testId }) => {
  const [h, setH] = useState(240);
  useEffect(() => {
    const on = (e) => {
      if (e.origin !== BACKEND_ORIGIN) return;
      let d = e.data;
      if (typeof d === "string") { try { d = JSON.parse(d); } catch { return; } }
      if (d && d.hkCalc && d.key === k) setH(Math.max(120, d.height + 4));
    };
    window.addEventListener("message", on);
    return () => window.removeEventListener("message", on);
  }, [k]);
  return <iframe title={title} src={src} style={{ height: h }} className="w-full border-0 block transition-[height] duration-200" data-testid={testId} />;
};

export const AnlopPreview = ({ cid, rev }) => {
  const [which, setWhich] = useState("list");
  const [size, setSize] = useState("desktop");
  const k = `prev${which}${rev}`;
  const width = SIZES.find((s) => s[0] === size)[1];
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="anlop-preview">
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-b border-slate-100">
        <div className="inline-flex rounded-md border border-slate-200 p-0.5 bg-slate-50">
          {[["list", "Full anløpsliste"], ["teaser", "Neste anløp"]].map(([id, l]) => (
            <button key={id} type="button" onClick={() => setWhich(id)} data-testid={`anlop-preview-${id}`}
              className={`px-3 py-1.5 text-sm rounded transition-colors ${which === id ? "bg-white shadow-sm text-slate-900 font-medium" : "text-slate-600 hover:text-slate-900"}`}>{l}</button>
          ))}
        </div>
        <div className="inline-flex gap-1">
          {SIZES.map(([id, , Icon, l]) => (
            <button key={id} type="button" onClick={() => setSize(id)} title={l} aria-label={l} data-testid={`anlop-size-${id}`}
              className={`w-9 h-9 rounded-md flex items-center justify-center transition-colors ${size === id ? "bg-[#0A192F] text-white" : "text-slate-500 hover:bg-slate-100"}`}><Icon className="w-4 h-4" /></button>
          ))}
        </div>
      </div>
      <div className="bg-slate-50 p-3 sm:p-6 overflow-x-auto">
        <div className="mx-auto bg-white rounded-md shadow-sm p-3 sm:p-5 transition-[max-width] duration-300" style={{ maxWidth: width }}>
          <Frame key={k} k={k} title={which === "list" ? "Anløpsliste" : "Neste anløp"} testId={`anlop-frame-${which}`}
            src={`${BACKEND}/api/anlop/${cid}/${which}?k=${k}`} />
        </div>
      </div>
    </div>
  );
};
